<template>
  <div>
    <div class="pacific">
      <div class="bread">
        <p v-html="'HOME &nbsp; / &nbsp; COLLECTIONS &nbsp; / &nbsp PACIFIC'"></p>
      </div>
      <div class="pacific_banner">
        <div class="banner_pic">
          <img :src="bannerImg" alt="">
          <div class="bannertext">
            <h3>PACIFIC</h3>
            <p>Waves of mixed blue gems<br> and gold</p>
          </div>
        </div>
      </div>
      <!------- BLUE ------>
      <div class="bluewrap">
        <div class="blue_text col-12 col-md-6">
          <div class="imgs">
            <div class="mobile">
              <img :src="dotsMobile" alt="">
              <img class="darkblue" :src="dotsMobileDarkblue" alt="">
              <img class="green" :src="dotsMobileGreen" alt="">
              <img class="lightblue" :src="dotsMobileLightblue" alt="">
            </div>
            <div class="pcimg">
              <img :src="dots" alt="">
              <img class="darkblue" :src="dotsDarkblue" alt="">
              <img class="green" :src="dotsGreen" alt="">
              <img class="lightblue" :src="dotsLightblue" alt="">
            </div>
          </div>

          <h3>Concept</h3>
          <p>The Vintage collection is a celebration of beauty, timelessness and longevity. Kyanites or coloured stones are surrounded by a halo of shimmering Kyanites.
          </p>
        </div>
        <div class="blue_imgs col-12 col-md-6">
          <div class="imgwrap">
            <div class="bigimg">
              <img :src="oceanBig" alt="">
            </div>
            <div class="smallimg">
              <img :src="oceanSmall" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="ocean">
        <img class="pacific_small" :src="oceanBgMobile" alt="">
        <img class="pacific_big" :src="oceanBg" alt="">
      </div>
      <!------ PRODUCT_PICTURES ------>
      <div class="product_picture">
        <div class="row1">
          <div class="item col-6 col-md-4" v-for="(item, index) in productList" :key="index">
            <a :href="item.path">
              <img class="bigimg" :src="item.img" alt="">
              <div class="icon">
                <img :src="hoverIconHeart" alt="">
                <img :src="hoverIconCart" alt="">
              </div>
              <div class="item_text">
                <h4>{{item.name}}</h4>
                <p>{{`$ ${formatNum(item.price)}`}}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bannerImg from '@/assets/pc/pacific/banner_img.jpg'
import dotsMobile from '@/assets/pc/pacific/dots_mobile.png'
import dotsMobileDarkblue from '@/assets/pc/pacific/dots_mobile_darkblue.png'
import dotsMobileGreen from '@/assets/pc/pacific/dots_mobile_green.png'
import dotsMobileLightblue from '@/assets/pc/pacific/dots_mobile_lightblue.png'
import dots from '@/assets/pc/pacific/dots.png'
import dotsDarkblue from '@/assets/pc/pacific/dots_darkblue.png'
import dotsGreen from '@/assets/pc/pacific/dots_green.png'
import dotsLightblue from '@/assets/pc/pacific/dots_lightblue.png'
import oceanBig from '@/assets/pc/pacific/ocean_big.png'
import oceanSmall from '@/assets/pc/pacific/ocean_small.png'
import oceanBgMobile from '@/assets/pc/pacific/ocean_bg_mobile.png'
import oceanBg from '@/assets/pc/pacific/ocean_bg.png'
import productBigImg1 from '@/assets/pc/pacific/2-2.jpg'
import productBigImg2 from '@/assets/pc/pacific/1-2.jpg'
import productBigImg3 from '@/assets/pc/pacific/1-3.jpg'
import productBigImg4 from '@/assets/pc/pacific/2-1.jpg'
import productBigImg5 from '@/assets/pc/pacific/1-1.jpg'
import productBigImg6 from '@/assets/pc/pacific/2-3.jpg'

import hoverIconHeart from '@/assets/pc/earrings/hover_icon_heart02.png'
import hoverIconCart from '@/assets/pc/earrings/hover_icon_cart02.png'
import { formatNum } from '@/util/number'

export default {
  data () {
    return {
      formatNum,
      bannerImg,
      dotsMobile,
      dotsMobileDarkblue,
      dotsMobileGreen,
      dotsMobileLightblue,
      dots,
      dotsDarkblue,
      dotsGreen,
      dotsLightblue,
      oceanBig,
      oceanSmall,
      oceanBgMobile,
      oceanBg,
      productBigImg1,
      productBigImg2,
      productBigImg3,
      productBigImg4,
      productBigImg5,
      productBigImg6,
      hoverIconHeart,
      hoverIconCart,
      productList: [
        { path: '/ProductDetail', img: productBigImg1, name: 'PACIFIC BLUES EARRINGS', price: 2060 },
        { path: '#', img: productBigImg2, name: 'PACIFIC DROP BRACELET', price: 1060 },
        { path: '#', img: productBigImg3, name: 'PACIFIC NECKLACE', price: 2890 },
        { path: '#', img: productBigImg4, name: 'PACIFIC BLUES RING', price: 1080 },
        { path: '#', img: productBigImg5, name: 'PACIFIC DROP BRACELET', price: 1380 },
        { path: '#', img: productBigImg6, name: 'PACIFIC BLUES EARRINGS', price: 2080 }
      ]
    }
  }
}
</script>
